module.exports = new __parcel__URL__("base_raid_button_bg.122a048c.png").toString();